import "./AboutUs.css";

import iconVoice from "../../assets/voice.png";
import iconSms from "../../assets/sms.png";
import iconEsim from "../../assets/esim.png";
import iconNumber from "../../assets/number.png";
import iconFraud from "../../assets/fraud.png";
import awardImg from "../../assets/award.jpg";
import awardImg2025 from "../../assets/award2025.jpg";
import { Helmet } from "react-helmet";

export default function AboutUs() {
  const services = [
    {
      key: "voice",
      title: "Voice Solutions",
      text: "Advanced services such as traffic transit, SIP trunking, and cloud-based call center capabilities tailored for enterprise-level operations and wholesale clients.",
      icon: iconVoice,
    },
    {
      key: "sms",
      title: "SMS Services",
      text: "High-deliverability messaging solutions, including SMS transit and enterprise SMS, all backed by APIs and enhanced security — suitable for global campaigns.",
      icon: iconSms,
    },
    {
      key: "esim",
      title: "Data & eSIM",
      text: "Cutting-edge roaming and eSIM solutions enabling carrier switching without a physical SIM. Real-time management, AI-powered network selection, and cost-efficient plans are at the core.",
      icon: iconEsim,
    },
    {
      key: "number",
      title: "Number Services",
      text: "Local, national, toll-free, premium, shared-cost, and UIFN numbers to strengthen global communication infrastructure.",
      icon: iconNumber,
    },
    {
      key: "fraud",
      title: "Fraud Prevention",
      text: "AI-based scam/spam recognition, SIM box detection, and roaming/foreign network testing to protect cross-border communications.",
      icon: iconFraud,
    },
  ];

  return (
    <main className="about">
      <Helmet>
        <title>GlobTel Esim - About Us</title>
      </Helmet>
      <header className="about__hero">
        <h1>About Us</h1>
        <p className="about__lead">
          Globtel GmbH is a leading global telecommunications provider offering
          a broad portfolio of services designed to meet the evolving needs of
          businesses.
        </p>
      </header>

      <section className="about__services" aria-label="Our services">
        {/* <h2>What We Do</h2> */}

        <div className="tiles">
          {services.map((s) => (
            <article key={s.key} className="tile">
              <div className="tile__icon" aria-hidden="true">
                <img src={s.icon} alt="" />
              </div>
              <h3 className="tile__title">{s.title}</h3>
              <p className="tile__text">{s.text}</p>
            </article>
          ))}
        </div>

        <p className="about__note">
          From its headquarters in Berlin, supported by regional offices in
          Warsaw and Jurmala, Globtel delivers customisable, carrier-grade
          telecom services globally, balancing quality and cost efficiency with
          deep sensitivity to partner needs.
        </p>
      </section>

      <section className="about__award" aria-label="Award">
        <div className="award__inner">
          <div className="award__content award__content--right">
            <h3 className="award__title">
              Four Prestigious Wins, Including First Place in "Best eSIM
              Provider."
            </h3>

            <p className="award__lead">
              Globtel Triumphs at the Antonio Meucci Global Telco Awards 2025.
            </p>

            <a
              className="award__link1"
              href="https://globtel.biz/uncategorized/antonio-meucci-2025-press-release/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Read full story
            </a>
          </div>

          <div className="award__media">
            <img
              src={awardImg2025}
              alt="Antonio Meucci Global Telco Awards 2025"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="about__award" aria-label="Award">
        <div className="award__inner">
          <div className="award__media">
            <img
              src={awardImg}
              alt="Antonio Meucci Global Telco Awards 2024"
              loading="lazy"
            />
          </div>

          <div className="award__content">
            <h3 className="award__title">
              Our services were recognized as the
              <br />
              “Most Innovative Roaming Solution.”
            </h3>

            <p className="award__lead">
              The honor was presented at the Antonio Meucci Global Telco Awards
              2024.
            </p>

            <a
              className="award__link1"
              href="https://globtel.biz/uncategorized/success-on-antonio-meucci-awards-2024/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Read full story
            </a>
          </div>
        </div>
      </section>

      <section className="about__cta" aria-label="More information">
        <div className="cta__inner">
          <h3>Learn more about our services</h3>
          <p>For full details, visit our main website.</p>
          <a
            className="btn btn--primary"
            href="https://globtel.de/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Visit Globtel.de
          </a>
        </div>
      </section>
    </main>
  );
}
